import { RestApiResponse } from '../../common/rest-api.response';
import { NomenclatureTypeChild } from '../nomenclature-type-child';

export class NomenclatureTypeChildGetResponse extends RestApiResponse {
    public item: NomenclatureTypeChild;

    constructor(data?: Partial<NomenclatureTypeChildGetResponse>) {
        super(data);
        this.item = new NomenclatureTypeChild(data?.item);
    }
}
